import { Button, Collapse, FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Paper, TextField, Typography, makeStyles } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { Alert } from "@material-ui/lab";
import { useContext, useState } from "react";
import { Link, useRedirect } from "react-admin";
import { useLocation } from "react-router-dom";
import { AppContext } from "../../../providers/app-context-provider/app.context";
import authProvider from "../../../providers/auth-provider";
import BackgroundImageCarousel from "../layout/background-image-carousel";
import { InstitutionSelector } from "./component/institution-selector";
import { ProductSelector } from "./component/product-selector";

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },

  carouselContainer: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },

  image: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    transition: 'opacity 1s ease-in-out',
  },

  imageVisible: {
    opacity: 1,
  },

  imageNotVisible: {
    opacity: 0
  },

  paper: {
    paddingInline: theme.spacing(4),
    paddingBlock: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },

  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  logo: {
    backgroundImage: `url(https://game-juridico.s3.sa-east-1.amazonaws.com/assets/logos/Juristta_Title_Logo_White.png)`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    height: '125px',
    width: '100%',
    marginTop: '32px'
  },
  waveBackground: {
    backgroundImage: `url(https://game-juridico.s3.sa-east-1.amazonaws.com/assets/layout_images/Login_Wave_Pattern_White.png)`,
    backgroundPosition: 'bottom',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%'
  },
}));

const MultiStepForm = () => {

  const [step, setStep] = useState(0)
  const [contexts, setContexts] = useState(null)
  const [products, setProducts] = useState(null)
  const [user, setUser] = useState(null)

  const appContext = useContext(AppContext)
  const location = useLocation()

  const finishLoginContext = async (username, password, context, product, contexts, redirect) => {
    await authProvider.loginContext({ username, password, context: context.id, product: product.id, contexts })
      .then((res) => {
        appContext.setContext(res)
        appContext.setContexts(contexts)
        const { nextPathname, nextSearch } = location.state || {}
        redirect(nextPathname ? `${nextPathname}${nextSearch || ''}` : '/')
      })
      .catch(err => console.error(err))
  }

  switch (step) {
    default:
    case 0:
      return <CredentialsForm setStep={setStep} setContexts={setContexts} setProducts={setProducts} setUser={setUser} finishLogin={finishLoginContext} />
    case 1:
      return <InstitutionSelector user={user} contexts={contexts} setStep={setStep} setProducts={setProducts} setUser={setUser} finishLogin={finishLoginContext} />
    case 2:
      return <ProductSelector user={user} products={products} contexts={contexts} finishLogin={finishLoginContext} />
  }
}


const CredentialsForm = ({ setStep, setContexts, setProducts, setUser, finishLogin, ...props }) => {
  const classes = useStyles();
  const redirect = useRedirect();
  const location = useLocation();
  const queryProductId = new URLSearchParams(location.search).get('product');
  const Copyright = () => {
    return (
      <Typography variant="body2" color="textSecondary" align="center"> {'Copyright © '}
        <Link color="inherit" href="https://www.juristta.com.br/"> Juristta </Link>
        {' '} {new Date().getFullYear()} {'.'}
      </Typography>
    );
  }

  const onSubmit = async (event) => {
    event.preventDefault();
    await authProvider.getUserContexts({ username, password })
      .then(async res => {
        const contexts = res.data
        const user = contexts[0].user
        setContexts(contexts);
        if (contexts.length === 1) {
          const products = contexts[0].institution_branch.institution.products
          const matchedProduct = queryProductId && products.find(product => String(product.id) === queryProductId)
          if (products.length === 1) {
            await finishLogin(username, password, contexts[0], products[0], contexts, redirect)
          } else if (matchedProduct) {
            await finishLogin(username, password, contexts[0], matchedProduct, contexts, redirect)
          } else {
            setUser({ name: user.name, username, password, context: contexts[0] })
            setProducts(products)
            setStep(2)
          }
        } else {
          setUser({ name: user.name, username, password })
          setStep(1);
        }
      }).catch(err => {
        setErrorMessage('Usuário ou senha inválidos')
        setError(true)
      })
  }

  const [username, setUsername] = useState(null)
  const [password, setPassword] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const handleClickShowPassword = () => setShowPassword(!showPassword)
  const handleMouseDownPassword = (event) => event.preventDefault()
  const handleUsernameChange = (event) => setUsername(event.target.value.trim())
  const handlePasswordChange = (event) => setPassword(event.target.value.trim())
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')

  return (
    <>
      <div className={classes.logo} />
      <form className={classes.form} noValidate >
        <TextField
          id="email"
          type="text"
          value={username}
          label="Email"
          onChange={handleUsernameChange}
          variant="outlined"
          margin="dense"
          fullWidth
          name="email"
          autoComplete="email"
          autoFocus
        />
        <FormControl fullWidth margin="dense" variant="outlined">
          <InputLabel htmlFor="outlined-adornment-password">Senha</InputLabel>
          <OutlinedInput
            id="outlined-adornment-password"
            type={showPassword ? 'text' : 'password'}
            value={password}
            label="Senha"
            onChange={handlePasswordChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </FormControl>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={onSubmit}
        >
          Entrar
        </Button>
      </form>

      <Collapse style={{ margin: 'auto', width: '100%' }} in={error}>
        <Alert severity="error" onClose={() => setError(false)}>
          {errorMessage}
        </Alert>
      </Collapse>

      <div style={{ marginBlock: '8px' }}>
        <Button onClick={() => redirect('/password-reset')}>Esqueceu sua senha?</Button>
      </div>
      <Copyright />
    </>
  )
}

export const LoginPage = (props) => {

  const classes = useStyles();

  return (
    <Grid container style={{ height: '100vh' }} spacing={0}>
      <Grid item xs={false} sm={6} md={8}>
        <BackgroundImageCarousel />
      </Grid>
      <Grid className={classes.waveBackground} item xs={12} sm={6} md={4} component={Paper} elevation={6} square>
        <div className={classes.paper}>
          <MultiStepForm />
        </div>
      </Grid>
    </Grid>
  )

}